export const makeSearchResultColumn = () => {
  return [
    {
      header: 'Type',
      accessorKey: 'type',
      size: 110,
      style: { textAlign: 'center' },
    },
    {
      header: 'Description',
      accessorKey: 'description',
      size: 1000,
      maxWidth: 1000,
      cell: ({ row }) => {
        if (row.original.type === 'Reader') return `${row.original.description} - ${row.original.data.imei}`;

        return row.original.description;
      },
    },
  ] as Array<any>;
};
